var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    {
      key: _vm.source.id,
      staticClass: "activity shadow mb-3 mx-2",
      attrs: { "no-body": "" }
    },
    [
      _c(
        "b-avatar",
        {
          directives: [
            {
              name: "has-permission",
              rawName: "v-has-permission",
              value: "ED081",
              expression: "'ED081'"
            }
          ],
          staticClass: "activity-handler",
          attrs: { rounded: "", variant: "light-secondary", size: "24" }
        },
        [_c("feather-icon", { attrs: { icon: "CrosshairIcon" } })],
        1
      ),
      _c(
        "b-card-body",
        { staticClass: "p-2" },
        [
          _c(
            "b-card-title",
            {
              staticClass: "activity-description font-weight-normal mb-0 pr-8",
              on: {
                click: function($event) {
                  return _vm.onSelect(_vm.source)
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.source.name) + " ")]
          ),
          _c("hr", { staticClass: "my-2" }),
          _vm.source.companyStatusName && _vm.source.companyStatusName !== "--"
            ? _c(
                "b-badge",
                {
                  staticClass: "text-wrap mb-1",
                  attrs: { variant: "light-primary" }
                },
                [
                  _c("feather-icon", { attrs: { icon: "TrelloIcon" } }),
                  _vm._v(" " + _vm._s(_vm.source.companyStatusName) + " ")
                ],
                1
              )
            : _vm._e(),
          !_vm.source.companyStatusName || _vm.source.companyStatusName === "--"
            ? _c(
                "b-badge",
                {
                  staticClass: "text-wrap mb-1",
                  attrs: { variant: "light-danger" }
                },
                [
                  _c("feather-icon", { attrs: { icon: "TrelloIcon" } }),
                  _c("feather-icon", {
                    staticClass: "ml-2",
                    attrs: { icon: "AlertCircleIcon" }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            [
              _c("b-badge", { attrs: { variant: "light-primary" } }, [
                _vm._v(" " + _vm._s(_vm.source.referenceElementType) + " ")
              ]),
              _vm.source.referenceId && _vm.source.referenceElementNumber
                ? _c(
                    "b-badge",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip",
                          value: _vm.source.referenceId,
                          expression: "source.referenceId"
                        }
                      ],
                      staticClass: "ml-1 text-wrap mb-2",
                      attrs: { variant: "light-success" }
                    },
                    [
                      _vm._v(
                        " #" + _vm._s(_vm.source.referenceElementNumber) + " "
                      ),
                      _c("feather-icon", { attrs: { icon: "FileTextIcon" } })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c("ActivityAliveBadge", {
                attrs: {
                  "created-at": _vm.source.createdAt,
                  "expired-at": _vm.source.expiredAt
                }
              }),
              _vm.source.meta.isUpdating
                ? _c("b-spinner", {
                    staticClass: "ml-1",
                    attrs: { small: "", variant: "primary" }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }